export default "__VITE_ASSET__MQeeuXc2__"